module.exports = __webpack_public_path__ + "static/media/John Adams - 1788.a78a5653.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/John Adams - 1788.jpg
// module id = 512
// module chunks = 0